The tax details of the ad product price.
